import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubmittedFormsDetailsService {

  constructor(
    private _http: HttpClient
  ) { }

  getFormDetails(formId) {
    return this._http.get(environment.url + "/getFormDetails/" + formId);
  }

  updateFormDetails(formData) {
    return this._http.put(environment.url + "/form/", formData);
  }

  makeFormRead(requestDetails) {
    return this._http.post(environment.url + "/makeFormRead/", requestDetails);
  }

  printForm(formId) {
    return this._http.get(environment.url + "/print/" + formId + "?timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone)
  }
}
